export const clearLocalStorageOnSuccessPayment = () => {
  localStorage.removeItem('isPDConsentAlternativeVersion');
  localStorage.removeItem('paymentSubscriptionId');
};
